<header>
  <div class="left">
    <button mat-button routerLink="/">
      <mat-icon>arrow_back</mat-icon>
      Dashboard
    </button>
  </div>

  <div class="right">
    <span class="copy-message" *ngIf="copyMessage">{{ copyMessage }}</span>
    <span class="copy-message" *ngIf="!copyMessage && getInvoiceMatchCount()">
      {{ getInvoiceMatchCount() }} invoice matches
    </span>
    <button mat-stroked-button (click)="copyTransactions()" [disabled]="isLoading || dataSource.data.length === 0">
      <mat-icon>content_copy</mat-icon>
      Copy for ChatGPT
    </button>
    <button mat-button (click)="previousWeek()" [disabled]="isLoading">
      <mat-icon>chevron_left</mat-icon>
      Previous
    </button>
    <button mat-button (click)="currentWeek()" [disabled]="isLoading">Current week</button>
    <button mat-button (click)="nextWeek()" [disabled]="isLoading">
      Next
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
</header>

<div class="weekly-report">
  <section class="report-heading">
    <div>
      <p>Weekly report</p>
      <h1>{{ weekStart | date:'dd MMM yyyy' }} - {{ weekEnd | date:'dd MMM yyyy' }}</h1>
    </div>

    <div class="week-status" *ngIf="isLoading">
      <mat-spinner diameter="24"></mat-spinner>
      Loading
    </div>
  </section>

  <section class="summary-grid">
    <div class="summary-tile revenue">
      <span>Revenue net of GST</span>
      <strong>{{ summary.revenue | human:true }}</strong>
      <small>GST {{ summary.revenueGst | human:true }}</small>
    </div>

    <div class="summary-tile expenses">
      <span>Expenses net of GST</span>
      <strong>{{ summary.expenses | human:true }}</strong>
      <small>GST {{ summary.expensesGst | human:true }}</small>
    </div>

    <div class="summary-tile wages">
      <span>Wages</span>
      <strong>{{ summary.wages | human:true }}</strong>
      <small>Payroll outgoings</small>
    </div>

    <div class="summary-tile profit" [class.negative]="summary.profit < 0">
      <span>Net result</span>
      <strong>{{ summary.profit | human:true }}</strong>
      <small>{{ summary.transactionCount }} transactions</small>
    </div>
  </section>

  <section class="report-columns">
    <div class="report-panel">
      <div class="section-heading">
        <h2>Revenue by source</h2>
      </div>

      <div class="group-list" *ngIf="revenueGroups.length; else noRevenue">
        <div class="group-row" *ngFor="let group of revenueGroups">
          <div>
            <strong>{{ group.label }}</strong>
            <span>{{ group.count }} transactions</span>
          </div>
          <div class="amounts">
            <strong>{{ group.amount | human:true }}</strong>
            <span>GST {{ group.gst | human:true }}</span>
          </div>
        </div>
      </div>

      <ng-template #noRevenue>
        <div class="empty-state">No revenue recorded for this week.</div>
      </ng-template>
    </div>

    <div class="report-panel">
      <div class="section-heading">
        <h2>Expenses by supplier/category</h2>
      </div>

      <div class="group-list" *ngIf="expenseGroups.length; else noExpenses">
        <div class="group-row" *ngFor="let group of expenseGroups">
          <div>
            <strong>{{ group.label }}</strong>
            <span>{{ group.count }} transactions</span>
          </div>
          <div class="amounts">
            <strong>{{ group.amount | human:true }}</strong>
            <span>GST {{ group.gst | human:true }}</span>
          </div>
        </div>
      </div>

      <ng-template #noExpenses>
        <div class="empty-state">No expenses recorded for this week.</div>
      </ng-template>
    </div>
  </section>

  <section class="report-panel transactions-panel">
    <div class="section-heading">
      <h2>Transactions</h2>
    </div>

    <table mat-table [dataSource]="dataSource" class="transactions">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let element">{{ element.date | date:'dd-MM-yy' }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let element">{{ getDescription(element) }}</td>
      </ng-container>

      <ng-container matColumnDef="account">
        <th mat-header-cell *matHeaderCellDef>Account</th>
        <td mat-cell *matCellDef="let element">{{ getAccountLabel(element) }}</td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Net Amount</th>
        <td mat-cell *matCellDef="let element" class="amount">{{ getTransactionNetAmount(element) | human:true }}</td>
      </ng-container>

      <ng-container matColumnDef="gst">
        <th mat-header-cell *matHeaderCellDef>GST</th>
        <td mat-cell *matCellDef="let element" class="amount">{{ element.vat | human:true }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr
        mat-row
        class="transaction-row"
        (click)="openTransactionDialog(row, i)"
        *matRowDef="let row; let i = dataIndex; columns: columnsToDisplay;">
      </tr>
    </table>
  </section>
</div>
